<template>
  <b-container>
    <b-row class="ro-margin p-3">
      <b-col sm="12" lg="6" class="xs-6 col-print-6 pt-4">
        <h3>Hankkeen määritetyt lähtötiedot</h3>
        <p><b>Käyttötarkoitus:</b> {{ kayttotarkoitus }}</p>
        <p><b>Kerrosala:</b> {{userSelection.kerrosala}} m<sup>2</sup></p>
        <p><b>Kerrosmäärä:</b> {{userSelection.kerrosmaara}}</p>
        <p><b>Henkilömäärä:</b> {{userSelection.henkilomaara}}</p>
        <p><b>Korkeus:</b> {{userSelection.korkeus}} m</p>
        <p><b>Sprinklaus:</b> {{userSelection.sprinklaus}}</p>
        <p><b>Palo-osaston koko:</b> {{userSelection.tilat}} m<sup>2</sup></p>
        <p><b>Paloluokka:</b> {{ paloluokka }}</p>
        <p v-if="item.acf.tyyppi === 20 || item.acf.tyyppi === 21">
          <b>Seinäpinta:</b> <span v-html="pintaluokat.seinapinta"></span>
        </p>
        <p v-if="item.acf.tyyppi === 22 || item.acf.tyyppi === 23">
          <b>Kattopinta:</b> <span v-html="pintaluokat.kattopinta"></span>
        </p>
        <p v-if="item.acf.tyyppi === 22">
          <b>Lattiapinta:</b> <span v-html="pintaluokat.lattiapinta"></span>
        </p>
        <p v-if="item.acf.tyyppi === 20">
          <b>Tuuletusraon sisäpinta:</b> <span v-html="pintaluokat.tspinta"></span>
        </p>
        <p v-if="item.acf.tyyppi === 20">
          <b>Tuuletusraon ulkopinta:</b> <span v-html="pintaluokat.tupinta"></span>
        </p>
        <p v-if="item.acf.tyyppi === 20">
          <b>Ulkoverhouksen ulkopinta:</b> <span v-html="pintaluokat.uupinta"></span>
        </p>
      </b-col>
      <b-col sm="12" lg="6" class="xs-6 col-print-6 text-center pt-2">
       <img :id="'kaavio_' + item.id" class="img-fluid img-kaavio" :src="item.acf.kaavio" alt="kaaviokuva">
      </b-col>
    </b-row>
    <b-row class="ro-margin pt-3">
      <b-col cols="12">
        <b-table
          id="m-table"
          :items="item.acf.diagram"
          :fields="fields"
          striped
          bordered
        >
          <template slot="Nro" slot-scope="data">{{ data.index + 1 }}</template>
          <span slot="rakennekerros" slot-scope="data" v-html="data.value"></span>
          <span slot="t_mm" slot-scope="data" v-html="data.value"></span>
          <span slot="paloon_reagointi" slot-scope="data" v-html="data.value"></span>
        </b-table>
        <div class="under-diagram" v-html="item.acf.lisatiedot"></div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { fields } from '../data/constants.js'
console.debug(fields)
export default {
  name: 'Item',
  props: {
    item: Object,
    paloluokka: String,
    kayttotarkoitus: String,
    pintaluokat: Object
  },
  data () {
    return {
      fields: fields
    }
  }
}
</script>
<style scoped>
  .img-kaavio {
    max-height: 460px;
  }

  .ro-margin {
    margin: 0;
    width: 100%;
  }

  p {
    margin: 0 0 0.5em 0;
  }

  #m-table thead tr th {
    border: none;
  }

  .under-diagram {
    text-align: left;
  }

  #m-print :first-child {
    margin-right: 0.5rem;
  }
  /*
  @media print {
    .print-50 {
      flex: 0 0 50% !important;
      max-width: 50% !important;
    }
    .no-print {
      display: none;
    }
    .img-kaavio-off{
      width: 50%;
      float: none;
      display: inline-block;
      vertical-align: top;
      padding: 0;
      margin: 0;
      margin-top: -300px;
    }
  }*/

</style>



// WEBPACK FOOTER //
// src/components/Item.vue